module.exports = __webpack_public_path__ + "img/icon_map_37_off_101.ede909ba.png";